export interface Step {
  id: string;
  title: string;
}

export function Steps({
  steps,
  currentStep,
}: {
  steps: Step[];
  currentStep: number;
}) {
  return (
    <div className="flex justify-center">
      <ul className="steps">
        {steps.map((step, index) => (
          <li
            key={step.id}
            className={`step ${index <= currentStep ? 'step-primary' : ''}`}
          >
            {step.title}
          </li>
        ))}
      </ul>
    </div>
  );
}
